import axios from 'axios'

const API_PATH = 'api/v2/admins/merchants/inbounds/items'

const MerchantInboundItemsApiV2 = {
  /**
   * Invoke `PATCH api/v2/admins/merchants/inbounds/items/:id/curate`
   * endpoint to update quantity accepted and rejected of merchant inbound item
   */
  curate: (
    values,
    id
  ) =>  {
    const path     = `${API_PATH}/${ id }/curate`
    const body     = {
      item: values
    }
    const response = axios.patch(path, body)
    return response
  },

  /**
   * Show Merchant Inbound Item by specific id
   * Inovke `GET api/v2/admins//merchant/inbounds/items/:id`
   * @param {number} id Merchant Inbound Item Id's ID
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  }
}

export default MerchantInboundItemsApiV2
